export default __webpack_public_path__ + "static/media/Prev.b00afa39.svg";